import { Button } from 'antd'
import React from 'react'
import { Lang } from '../SubmissionV2/translations'
import { useCwdLang } from './useCwdLang'

export const LINE_ICON =
  'https://ts-upload.sgp1.digitaloceanspaces.com/cms/17UmBKpMFpFyWcD2bkWqogewV3BahiXQ2ekiwzJvUDgA1gee6K3mQDaGMQGULEVoHJYpSTrPb57KaszybWfA6Loo.png'
export const LINE_URL = 'https://line.me/R/ti/p/@haup.partner'

export const VEHICLE_TYPES = [
  'Sedan',
  'Hatchback',
  'SUV',
  'Van',
  'MVP',
  'Premium Sedan',
  'Premium Van',
  'Bus',
]

// origin/destination (Thai) are the persisted values; *En are display-only.
export const POPULAR_ROUTES = [
  {
    id: 'suvarnabhumi-bkk',
    origin: 'สนามบินสุวรรณภูมิ',
    destination: 'กรุงเทพมหานคร (ใจกลาง)',
    originEn: 'Suvarnabhumi Airport',
    destinationEn: 'Bangkok (City Center)',
  },
  {
    id: 'donmueang-bkk',
    origin: 'สนามบินดอนเมือง',
    destination: 'กรุงเทพมหานคร (ใจกลาง)',
    originEn: 'Don Mueang Airport',
    destinationEn: 'Bangkok (City Center)',
  },
  {
    id: 'suvarnabhumi-pattaya',
    origin: 'สนามบินสุวรรณภูมิ',
    destination: 'พัทยา',
    originEn: 'Suvarnabhumi Airport',
    destinationEn: 'Pattaya',
  },
  {
    id: 'suvarnabhumi-huahin',
    origin: 'สนามบินสุวรรณภูมิ',
    destination: 'หัวหิน',
    originEn: 'Suvarnabhumi Airport',
    destinationEn: 'Hua Hin',
  },
  {
    id: 'suvarnabhumi-chiangmai',
    origin: 'สนามบินสุวรรณภูมิ',
    destination: 'เชียงใหม่',
    originEn: 'Suvarnabhumi Airport',
    destinationEn: 'Chiang Mai',
  },
  {
    id: 'chiangmai-airport-city',
    origin: 'สนามบินเชียงใหม่',
    destination: 'ตัวเมืองเชียงใหม่',
    originEn: 'Chiang Mai Airport',
    destinationEn: 'Chiang Mai City',
  },
  {
    id: 'phuket-airport-city',
    origin: 'สนามบินภูเก็ต',
    destination: 'ตัวเมืองภูเก็ต',
    originEn: 'Phuket Airport',
    destinationEn: 'Phuket Town',
  },
  {
    id: 'phuket-airport-patong',
    origin: 'สนามบินภูเก็ต',
    destination: 'หาดป่าตอง',
    originEn: 'Phuket Airport',
    destinationEn: 'Patong Beach',
  },
  {
    id: 'samui-airport-city',
    origin: 'สนามบินเกาะสมุย',
    destination: 'ตัวเมืองเกาะสมุย',
    originEn: 'Samui Airport',
    destinationEn: 'Samui Town',
  },
]

// Translate a stored (Thai) popular-route place name for display.
export function localizePlace(name: string, lang: Lang) {
  if (lang !== 'EN') return name
  for (const r of POPULAR_ROUTES) {
    if (r.origin === name) return r.originEn
    if (r.destination === name) return r.destinationEn
  }
  return name
}

export const RequiredMark: React.FC = () => (
  <span style={{ color: '#ef4444', marginLeft: '2px' }}>*</span>
)

export const TopBar: React.FC<{ onExit?: () => void }> = ({ onExit }) => {
  const { t } = useCwdLang()
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px',
        borderBottom: '1px solid #f0f0f0',
        flexShrink: 0,
      }}
    >
      {onExit ? (
        <button
          onClick={onExit}
          style={{
            padding: '8px 20px',
            border: '1px solid #D6DAE0',
            borderRadius: '20px',
            backgroundColor: '#fff',
            cursor: 'pointer',
            fontSize: '14px',
            fontFamily: 'Poppins, sans-serif',
            color: '#333',
          }}
        >
          {t.common.saveAndExit}
        </button>
      ) : (
        <div />
      )}
      <button
        onClick={() => window.open(LINE_URL, '_blank', 'noopener,noreferrer')}
        style={{
          padding: '8px 16px',
          border: '1px solid #D6DAE0',
          borderRadius: '20px',
          backgroundColor: '#fff',
          cursor: 'pointer',
          fontSize: '14px',
          fontFamily: 'Poppins, sans-serif',
          color: '#333',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <img
          src={LINE_ICON}
          alt="LINE"
          style={{ width: '24px', height: '24px', objectFit: 'contain', flexShrink: 0 }}
        />
        {t.common.chatWithUs}
      </button>
    </div>
  )
}

export const ProgressHeader: React.FC<{
  currentStep: number
  totalSteps: number
  title: string
  currentStepProgress?: number
  maxStep?: number
}> = ({ currentStep, totalSteps, title, currentStepProgress, maxStep }) => {
  const { t } = useCwdLang()
  return (
    <div style={{ padding: '16px 16px 0' }}>
      <p
        style={{
          fontSize: '12px',
          fontWeight: '600',
          color: '#667085',
          textTransform: 'uppercase',
          margin: '0 0 4px',
        }}
      >
        {t.common.stepOf(currentStep, totalSteps)}
      </p>
      <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#212427', margin: '0 0 12px' }}>
        {title}
      </h2>
      <div style={{ display: 'flex', gap: '4px', marginBottom: '20px' }}>
        {Array.from({ length: totalSteps }).map((_, i) => {
          const sn = i + 1
          const effectiveMax = maxStep ?? currentStep
          const progress =
            sn < currentStep
              ? 100
              : sn === currentStep
              ? sn < effectiveMax
                ? 100
                : currentStepProgress ?? 50
              : sn <= effectiveMax
              ? 100
              : 0
          return (
            <div
              key={sn}
              style={{
                flex: 1,
                height: '4px',
                backgroundColor: '#D6DAE0',
                borderRadius: '2px',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  height: '100%',
                  width: `${progress}%`,
                  backgroundColor: '#00CCCC',
                  borderRadius: '2px',
                  transition: 'width 0.3s ease',
                }}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export const BottomNav: React.FC<{
  onBack: () => void
  onNext: () => void
  nextLabel?: string
  nextDisabled?: boolean
  loading?: boolean
}> = ({ onBack, onNext, nextLabel, nextDisabled = false, loading = false }) => {
  const { t } = useCwdLang()
  return (
    <div
      style={{
        display: 'flex',
        gap: '12px',
        padding: '16px',
        borderTop: '1px solid #f0f0f0',
        flexShrink: 0,
      }}
    >
      <Button block size="large" shape="round" onClick={onBack} disabled={loading}>
        {t.common.back}
      </Button>
      <Button
        block
        size="large"
        type="primary"
        shape="round"
        className="btn-primary-custom"
        onClick={onNext}
        disabled={nextDisabled}
        loading={loading}
      >
        {nextLabel ?? t.common.next}
      </Button>
    </div>
  )
}
